import { Component, OnInit, OnDestroy } from "@angular/core";
import { LogService } from "../../../modulo-comunes/servicios/log-servicios";
import { DataEmpresaService } from "../../../modulo-comunes/servicios/data-empresa-servicios";

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.css']
})
export class TopBarComponent implements OnInit, OnDestroy {
  empresa: string;
  sitio: string;
  config;
  configSub;
  logo1; //corto o delgado
  logo2; //mediano
  logo3; //ancho
  srcLogo;
  constructor(
    private logService: LogService,
    public dataEmpresaService: DataEmpresaService
  ) { }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  clickBoton(event) {
    this.logService.consoleLog('2', "PC TB 0");
    //document.getElementById("boton").classList.toggle("active");
    if (
      document.getElementById("miMenu").className.match(/(?:^|\s)nav-menu(?!\S)/)
    ) {
      document.getElementById("miMenu").className = "menu2";
    } else {
      document.getElementById("miMenu").className = "nav-menu w-nav-menu";
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  cerrarMenu(event) {
    this.logService.consoleLog('2', "PC TB 1");
    if (
      document.getElementById("miMenu").className.match(/(?:^|\s)menu2(?!\S)/)
    ) {
      document.getElementById("miMenu").className = "nav-menu w-nav-menu";
    }
  }
  asignaEstiloLogo(): object {
    let estilo = {};
    if (this.sitio == 'Efisys') {
      estilo = { "height": "70px", "margin-top": '0px', "margin-bottom": '0px', 'object-fit': 'contain', 'object-position': 'left' };
    } else if (this.sitio == 'EasyMed') {
      estilo = { 'object-fit': 'contain', 'object-position': 'left' };
    }
    return estilo;
  }

  ngOnInit() {
    //************************************************************************ */
    //Suscripción a config$. Corre cada vez que se modifica la config

    //this.srcLogo = "assets/images/imagen.jpg";
    this.sitio = this.dataEmpresaService.sitioElegido;
    if (this.sitio == 'EasyMed') {
      this.srcLogo = "assets/images/EMlogo2.svg";
    } else if (this.sitio == 'Efisys') {
      this.srcLogo = "assets/images/logo-efisys2.svg";
    }


    this.config = [];
    this.logo1 = "";
    this.logo2 = "";
    this.logo3 = "";
    this.empresa = "";

    /*
    this.configSub = this.prodService.config$.subscribe(p => {
      this.config = p;
      this.logo1 = p.logo1;
      this.logo2 = p.logo2;
      this.logo3 = p.logo3;
      this.empresa = p.empresa;
      this.logService.consoleLog('2', "PC TB configSub recibido: " + JSON.stringify(this.config));
    });
*/

    //************************************************************************ */
  }

  ngOnDestroy() {
    if (this.configSub) {
      //this.configSub.unsubscribe();
    }
  }
}
